import Experience from "../components/sections/experience/Experience";

const Work = () => {
  return (
    <div>
      <Experience />
    </div>
  );
};

export default Work;
